import { useQuery } from '@tanstack/react-query';
import useStoreSlug from 'src/common/hooks/useStoreSlug';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import GetUserNotificationsUseCase from 'src/features/inAppNotifications/domain/useCases/GetUserNotificationsUseCase';
import { GetUserNotificationsUseCaseInterface } from 'src/features/inAppNotifications/domain/useCases/types';
import { diContainer } from 'src/inversify.config';

const getUserNotificationsUseCase =
  diContainer.get<GetUserNotificationsUseCaseInterface>(
    GetUserNotificationsUseCase
  );

export default function useInAppNotifications() {
  const { storeSlug } = useStoreSlug();
  const { session } = useAuthContext();

  const query = useQuery({
    queryKey: ['inAppNotifications', storeSlug, session?.accessToken],
    queryFn: () => {
      return getUserNotificationsUseCase.execute({
        storeSlug,
        accessToken: session?.accessToken,
      });
    },
    enabled: !!storeSlug,
  });

  return {
    ...query,
    notifications: query.data,
  };
}
